import { render, staticRenderFns } from "./Lotto.vue?vue&type=template&id=1465f35e&scoped=true&"
import script from "./Lotto.vue?vue&type=script&lang=ts&"
export * from "./Lotto.vue?vue&type=script&lang=ts&"
import style0 from "./Lotto.vue?vue&type=style&index=0&id=1465f35e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1465f35e",
  null
  
)

export default component.exports